module.exports = __webpack_public_path__ + "img/公司官网_关于我们.7ef281ab.png";